<template>
	<l-map
			ref="mapRef"
			:zoom="13"
			:center="[latNumber, lonNumber]"
			style="height: 500px; width: 100%"
	>
		<l-tile-layer
				url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
				attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
		/>
		<l-marker :lat-lng="[latNumber, lonNumber]" />
	</l-map>
</template>

<script>
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
	iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
	iconUrl: require('leaflet/dist/images/marker-icon.png'),
	shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

// Иногда требуется поправить пути к иконкам для маркера.
// Подробнее: https://github.com/PaulLeCam/react-leaflet/issues/453#issuecomment-410450387

export default {
	name: 'MapComponent',
	components: {
		LMap,
		LTileLayer,
		LMarker,
	},
	props: {
		height: {
			type: String,
			default: '500px',
		},
		lat: {
			type: String,
			required: true,
		},
		lon: {
			type: String,
			required: true,
		},
	},
	computed: {
		// Преобразуем строки в числа
		latNumber() {
			return Number(this.lat);
		},
		lonNumber() {
			return Number(this.lon);
		},
	},
};
</script>

<style scoped>
/* При необходимости можно добавить стили для карты */
</style>
